import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'myDocuments',
      component: () => import('./views/Documents.vue'),
      meta: {
        sidebar: true,
        title: 'My Documents',
        icon: 'folder_open',
        endpoint: '/files',
        requestParams: {
          page: 'currentPage',
          limit: 'limit'
        }
      }
    },
    {
      path: '/company/:id',
      name: 'companyDocuments',
      component: () => import('./views/Documents.vue'),
      meta: {
        sidebar: true,
        title: 'Company Documents',
        icon: 'work',
        endpoint: '/files',
        requestParams: {
          groupId: '$route.params.id',
          page: 'currentPage',
          limit: 'limit'
        }
      }
    },
    {
      path: '/acs',
      name: 'acs',
      component: () => import('./views/Acs.vue')
    }
  ]
})
